export default __webpack_public_path__ + "static/media/nairaW.a6dbcc3b.svg";